// @ts-nocheck
const numberPattern = /\d+?\.\d+?/g; // keep digits and dots

export default (value: string) => {
    return Number(value.match(numberPattern)?.join(""));
};
